// extracted by mini-css-extract-plugin
module.exports = {"green":"#52793a","hover":"#fcffea","orange":"#f38620","grey":"#565656","greyLight":"#f1f1f1"};